import { useState, useEffect, useRef, MutableRefObject } from 'react'
/**
 *
 * Where we are referring to state variables inside event listeners,
 * tracking the data is more straight forward if we use a Ref.
 */
export function useReferredState<T>(
  initialValue: any
): [MutableRefObject<T>, (value: any) => void] {
  const [state, setState] = useState(initialValue)
  const reference = useRef(state)

  const setReferredState = (value: any) => {
    reference.current = value
    setState(value)
  }

  return [reference, setReferredState]
}

export function usePrevious<T>(value: T): T {
  const ref = useRef<T>(value)
  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}
